/* eslint-disable max-lines */
import { hasModule } from 'lib/helpers/utility';

export const practiceSidebar = ({ userState, practiceModules }) => ({
  dashboard: { path: 'dashboard', name: 'Dashboard', icon: 'dashboard-mono', end: true },
  appointments: {
    path: 'appointments',
    name: 'Calendar',
    icon: 'calendar-mono',
    end: false,
    requiredModules: 'core.calendar_scheduling.calendar'
  },
  charts: {
    path: 'charts',
    name: 'Charts',
    permission: 'patients.read',
    icon: 'users-mono',
    end: false
  },
  'beyond-billing': {
    path: 'beyond-billing',
    name: 'Beyond Billing',
    icon: 'billing-mono',
    permission: 'billing.read',
    end: false,
    isOpen: userState?.display_settings?.sidebars?.['beyond-billing']?.isOpen ?? false,
    children: [
      {
        title: 'Queues',
        children: [
          { path: 'beyond-billing', name: 'Overview', icon: 'graph-mono', end: true },
          {
            path: 'beyond-billing/income-i-queue',
            name: 'IncomeIQueue',
            icon: 'note-text-1-mono',
            permission: 'payments.read',
            requiredModules: 'medipay.payment_suite'
          },
          {
            path: 'beyond-billing/payments',
            name: 'Payments',
            icon: 'billing-mono',
            permission: 'payments.read',
            requiredModules: 'medipay.payment_suite'
          },
          {
            path: 'beyond-billing/plans',
            name: 'Plans',
            icon: 'billing-mono',
            permission: 'payments.read',
            requiredModules: 'medipay.payment_suite.recurring_charges'
          },
          {
            path: 'beyond-billing/patient-ledger',
            name: 'Patient ledger',
            icon: 'macro-mono',
            permission: 'payments.read',
            requiredModules: 'medipay.payment_suite'
          },
          {
            path: 'beyond-billing/superbills',
            name: 'Superbills',
            icon: 'billing-mono',
            permission: 'superbill.read',
            requiredModules: 'billing.superbills'
          },
          {
            path: 'beyond-billing/claims',
            name: 'Claims',
            icon: 'wallet-mono',
            requiredModules: 'billing.claims'
          },
          {
            path: 'beyond-billing/era',
            name: 'ERA',
            icon: 'receipt-1-mono',
            requiredModules: 'billing.era_eob_posting'
          },
          {
            path: 'beyond-billing/eob',
            name: 'EOB',
            icon: 'receipt-3-mono',
            requiredModules: 'billing.era_eob_posting'
          },
          {
            path: 'beyond-billing/electronic-invoicing',
            name: 'Electronic invoices',
            icon: 'file-invoice-mono',
            permission: 'billing.read'
          }
        ]
      },
      {
        title: 'Reports',
        children: [
          {
            path: 'beyond-billing/reports/standard',
            name: 'Standard reports',
            icon: 'chart-mono'
          },
          {
            path: 'beyond-billing/reports/favorite',
            name: 'Favorite reports',
            icon: 'chart-favorite-mono'
          },
          {
            path: 'beyond-billing/reports/custom',
            name: 'Custom reports',
            icon: 'chart-1-mono'
          }
        ],
        permission: 'reports.read',
        requiredModules: ['core.reporting_center', 'medipay.payment_suite']
      }
    ]
  },
  ...(hasModule(practiceModules, 'core.communication_center.hipaa_fax')
    ? {
        'comms-center': {
          path: 'comms-center',
          name: 'Comms Center',
          icon: 'modules-mono',
          end: false,
          isOpen: userState?.display_settings?.sidebars?.['comms-center']?.isOpen ?? false,
          children: [
            { path: 'comms-center', name: 'Fax', icon: 'efax-mono', end: true },
            { path: 'comms-center/inbound', name: 'Inbound faxes', icon: 'import-mono' },
            { path: 'comms-center/outbound', name: 'Outbound faxes', icon: 'export-mono' },
            { path: 'comms-center/drafts', name: 'Drafts', icon: 'note-text-1-mono' },
            { path: 'comms-center/archived', name: 'Archived', icon: 'archive-mono' },
            { path: 'comms-center/messages', name: 'Messages', icon: 'messages-mono' },
            { path: 'comms-center/contacts', name: 'Contacts', icon: 'contact-book-mono' }
          ]
        }
      }
    : {}),
  documents: {
    path: 'documents',
    name: 'Documents',
    permission: 'patient_documents_center.read',
    icon: 'first-line-mono',
    end: false
  },
  'practice-i-queue': {
    path: 'practice-i-queue',
    name: 'PracticeIQueue',
    icon: 'practiceiqueue-filled',
    isOpen: userState?.display_settings?.sidebars?.['practice-i-queue']?.isOpen ?? false,
    children: [
      { path: 'practice-i-queue', name: 'Overview', icon: 'graph-mono', end: true },
      {
        path: 'practice-i-queue/tasks',
        name: 'Tasks',
        icon: 'task-mono',
        permission: 'tasks.read'
      },
      {
        path: 'practice-i-queue/clinical-notes',
        name: 'Clinical notes',
        icon: 'note-mono',
        permission: 'clinical_note.read'
      },
      {
        path: 'practice-i-queue/treatment-plans',
        name: 'Treatment plans',
        icon: 'task-1-linear',
        permission: 'clinical_note.read'
      },
      { path: 'practice-i-queue/notifications', name: 'Notifications', icon: 'bell-mono' },
      {
        path: 'practice-i-queue/appointments',
        name: 'Appointments',
        icon: 'calendar-mono',
        permission: 'appointments.read'
      },
      {
        path: 'practice-i-queue/forms',
        name: 'Forms',
        icon: 'calendar-note-mono',
        permission: 'form_packet.read'
      },
      {
        path: 'practice-i-queue/orders',
        name: 'Orders',
        icon: 'note-text-1-mono'
      }
    ]
  },
  settings: {
    path: 'settings',
    name: 'Settings',
    icon: 'settings-mono',
    end: false,
    isOpen: userState?.display_settings?.sidebars?.['settings']?.isOpen ?? false,
    children: [
      {
        path: 'settings',
        name: 'Practice details',
        icon: 'user-square-mono',
        end: true
      },
      {
        path: 'settings/roles',
        name: 'Roles & permissions',
        permission: 'role.read',
        icon: 'users-mono'
      },
      {
        path: 'settings/staff',
        name: 'Staff',
        permission: 'member.read',
        icon: 'people-mono'
      },
      {
        path: 'settings/billing',
        name: 'Billing',
        permission: 'billing.read',
        icon: 'wallet-mono'
      },
      {
        path: 'settings/eprescribe',
        name: 'ePrescribe',
        permission: 'prescribe.read',
        icon: 'prescribe-mono'
      },
      {
        path: 'settings/calendar',
        name: 'Appointments',
        icon: 'calendar-2-mono',
        permission: 'appointments.read'
      },
      {
        path: 'settings/self-scheduling',
        name: 'Self scheduling',
        permission: 'appointments.read'
      },
      { path: 'settings/check-in-steps', name: 'Check-in steps' },
      {
        path: 'settings/patient-notifications',
        name: 'Patient notifications',
        icon: 'bell-mono'
      },
      {
        path: 'settings/forms',
        name: 'Forms',
        icon: 'calendar-note-mono',
        permission: 'form.read'
      },
      { path: 'settings/payers', name: 'Payers', icon: 'payers-mono' },
      { path: 'settings/kiosk', name: 'Kiosk', permission: 'kiosk.read', icon: 'kiosk-mono' },
      { path: 'settings/tags', name: 'Tags', icon: 'tag-mono', permission: 'tags.read' },
      {
        path: 'settings/services',
        name: 'Services',
        icon: 'star-1-filled',
        permission: 'services.read',
        requiredModules: 'core.services_products.services'
      },
      {
        path: 'settings/products',
        name: 'Products',
        icon: 'pill-mono',
        permission: 'products.read',
        requiredModules: 'core.services_products.products'
      },
      {
        path: 'settings/packages',
        name: 'Packages',
        icon: 'packages-mono',
        permission: 'packages.read',
        requiredModules: 'core.services_products.packages'
      },
      {
        path: 'settings/resources',
        name: 'Resources',
        icon: 'menu-board-mono',
        permission: ['resources.read', 'appointments.read']
      },
      {
        path: 'settings/automation',
        name: 'Automation',
        icon: 'settings-mono',
        permission: 'practice.update'
      },
      {
        path: 'settings/healthcare-program',
        name: 'Healthcare program',
        icon: 'health-mono',
        permission: 'practice.update'
      }
    ]
  }
});
